import React, {useContext, useEffect, useState} from "react";
import {
    HOME_ROUTE,
    LOGIN_ROUTE,
    PLUGINS_ROUTE,
    REGISTRATION_ROUTE,
    SERVER_SHOP_CATEGORIES, SERVER_SHOP_ITEMS,
    SERVERS_ROUTE, USER_CABINET_ROUTE, WALLET_PLAYER
} from "../utils/consts";
import {useNavigate} from "react-router-dom";
import {logout} from "../http/userAPI";
import {Context} from "..";
import {observer} from "mobx-react-lite";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';


const pages = ['Плагины', 'Управление сервером', 'Настройки'];

const HomeHeader = observer(() => {
    const {user} = useContext(Context);
    const [name, setName] = useState('');
    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [settings, setSetting] = useState([]);
    const [pages, setPages] = useState([]);

    useEffect(() => {
        if (user.userInfo && user.userInfo.role === 'admin' && user.userInfo.id === 2) {
            setPages([
                {
                    name: 'Главная',
                    page: HOME_ROUTE
                },
                {
                    name: 'Плагины',
                    page: PLUGINS_ROUTE
                },
                {
                    name: 'Категории магазина',
                    page: SERVER_SHOP_CATEGORIES
                },
                {
                    name: 'Товары магазина',
                    page: SERVER_SHOP_ITEMS
                },
                {
                    name: 'Управление сервером',
                    page: SERVERS_ROUTE
                }
            ]);
        }

        if (user.userName ) {
            setName(user.userName);
            setSetting([
                {
                    name: `Баланс: ${user.userInfo.balance ?? 0}₽ / Бонусы: ${user.userInfo.bonuses ?? 0}`,
                    page: WALLET_PLAYER
                },
                {
                    name: 'Личный кабинет',
                    page: USER_CABINET_ROUTE
                },
                {
                    name: 'Выход'
                }
            ]);
        } else if (user.userInfo && user.userInfo.login) {
            setName(user.userInfo.login);
            setSetting([
                {
                    name: `Баланс: ${user.userInfo.balance ?? 0}₽ / Бонусы: ${user.userInfo.bonuses ?? 0}`,
                    page: WALLET_PLAYER
                },
                {
                    name: 'Личный кабинет',
                    page: USER_CABINET_ROUTE
                },
                {
                    name: 'Выход'
                }
            ]);
        } else {
            setName('');
            setSetting([
                {
                    name: 'Авторизация',
                    page: LOGIN_ROUTE
                }, {
                    name: 'Регистрация',
                    page: REGISTRATION_ROUTE
                }
            ]);
            setPages([
                {
                    name: 'Главная',
                    page: HOME_ROUTE
                }
            ]);
        }

    }, [user.userName, user.userInfo]);


    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const click = async () => {
        console.log('выход')
        try {
            let data;
            data = await logout();
            user.setUser({});
            user.setUserName('');
            user.setRole('');
            user.setIsAuth(false);
            user.setUserInfo({});
            localStorage.setItem('token', '');
            navigate(HOME_ROUTE);
        } catch (e) {
            user.setUser({});
            user.setUserName('');
            user.setRole('');
            user.setIsAuth(false);
            user.setUserInfo({});
            localStorage.setItem('token', '');
            navigate(HOME_ROUTE);
        }
    }

    return(
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        onClick={() => {navigate(HOME_ROUTE);}}
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        Scraplands
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages && pages.map((page, index) => (
                                <MenuItem key={index} onClick={() => {
                                    handleCloseNavMenu();
                                    navigate(page.page);
                                }}>
                                    <Typography
                                        textAlign="center">{page.name}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        onClick={() => {navigate(HOME_ROUTE);}}
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        Scraplands
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages && pages.map((page, index) => (
                            <Button
                                key={index}
                                onClick={() => {
                                    handleCloseNavMenu();
                                    navigate(page.page);
                                }}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page.name}
                            </Button>
                        ))}
                    </Box>
                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Аккаунт">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt={name} src="/static/images/avatar/2.jpg" />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting, index) => (
                                <MenuItem key={index} onClick={handleCloseUserMenu}>
                                    {setting.page ?
                                        <Typography
                                            onClick={() => {
                                                navigate(setting.page);
                                            }}
                                            textAlign="center">{setting.name}</Typography>
                                        :
                                        <Typography
                                            onClick={() => click()}
                                            textAlign="center">{setting.name}</Typography>
                                    }
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );

});

export default HomeHeader;